export class LocalRoutes {
  //   static icons = '/assets/icons/';
  static logos = '/assets/icons/logos/';
  // static chatBotIcons = "/assets/icons/chat-bot/";
  static chat_bot_icons = '/assets/icons/chat-bot/';
  //   static material = '/assets/icons/material/';
}
